export class ColumnFilter {
    public fieldName: string;
    public operator: string;
    public values?: string[];
    public dateValues?: string[];



    public ToXml = (): string => {
        let result: string = "";
        result += this.fieldName.replace("#", "&hash;") + ";" + this.operator + ";";

        let valuestr: string = "";
        if (this.values && this.values.length > 0) {
            for (let value in this.values) {
                if (valuestr != "") {
                    valuestr += "&" + this.values[value].replace("#", "&hash;");
                } else {
                    valuestr = this.values[value].replace("#", "&hash;") ;
                }
            }
        } else
            valuestr = "null";

        let datestr: string = "";
        if (this.dateValues && this.dateValues.length > 0) {
            for (let date in this.dateValues) {
                if (datestr != "") {
                    datestr += "&" + this.dateValues[date];
                } else {
                    datestr = this.dateValues[date];
                }
            }
        } else
            datestr = "null";

        result += valuestr + ";" + datestr;

        return result;
    }
}